import VideoList from "./VideoList";
import VideoEdit from "./VideoEdit";
import VideoCreate from "./VideoCreate";
import VideoShow from "./VideoShow";
import VideoIcon from "@mui/icons-material/OndemandVideo";

const videos = {
  list: VideoList,
  edit: VideoEdit,
  create: VideoCreate,
  show: VideoShow,
  icon: VideoIcon,
};

export default videos;
